export const TOGGLE_MENU = 'TOGGLE_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const TOGGLE_SUB_MENU = 'TOGGLE_SUB_MENU';

export const toggleMenu = () => ({ type: TOGGLE_MENU });
export const closeMenu = () => ({ type: CLOSE_MENU });
export const toggleSubMenu = (id) => ({ type: TOGGLE_SUB_MENU, payload: id });
